// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"245":"c9457bae081c8e9b","2888":"e6d4ce9e102ae386","5232":"c9457bae081c8e9b","5563":"79c6a6400c928e04","6213":"c9457bae081c8e9b"}[chunkId] + ".css";
};